import type { Nullable } from '@iheartjane/types';

import { createUseQueryHook } from '../createUseQueryHook';
import { STALE_TIMES } from '../reactQueryClientConfig';
import { fetchCommunicationBanner } from './communicationBanner.api';
import type { CommunicationBanner } from './communicationBanner.types';
import { communicationBannerQueryKeys } from './communicationBanner.utils';

/**
 * A store's communication banner
 *   V1::Stores::BannerMessageSettingsController#show
 *   GET /stores/:storeId/banner_message_settings
 */
export const useCommunicationBanner = createUseQueryHook<
  string | number,
  Nullable<CommunicationBanner>
>(
  fetchCommunicationBanner,
  communicationBannerQueryKeys.detail,
  (storeId) => !!storeId,
  { staleTime: STALE_TIMES.short }
);
